import { render, staticRenderFns } from "./DocumentCardView.vue?vue&type=template&id=6c75ec21&scoped=true&"
import script from "./DocumentCardView.vue?vue&type=script&lang=js&"
export * from "./DocumentCardView.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCardView.vue?vue&type=style&index=0&id=6c75ec21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c75ec21",
  null
  
)

export default component.exports